(function(){
  'use strict';

  angular
    .module('app.news')
    .component('newsCard', newsCardComponent());

  function newsCardComponent() {
    return {
      templateUrl: 'news/news-card.template.html',
      bindings: {
        name: '=',
        image: '=?',
        description: '=?',
        readMore: '=?',
        video: '=?',
        noCta: '=?'
      },
      controller: NewsCardController,
      controllerAs: 'vm',
      transclude: false
    }
  }

  function NewsCardController() {
    let vm = this;

  }

})();
